module.exports = __webpack_public_path__ + "img/huashu.2c1185d6.png";